import React, { useState } from "react";
import Styles from "./ChildTransaction.module.css";
import { CircularProgress, Modal, Tooltip } from "@mui/material";
import { Close, Info } from "@mui/icons-material";
import { useSelector } from "react-redux";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Payouts from "../../Schedule/Payouts/Payouts";
import Settlement from "../../Schedule/Settlement/Settlement";
import { convertDate, formatDateElement } from "../../../../commons/FormatDate";
import { getWalletActivities } from "../../../../Services/Schedule/schedule";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

const ChildTransaction = ({ open, handleClose, data, parentData }) => {
  const trader = useSelector((state) => state?.persistedReducer);

  const traderParent = trader?.roles?.includes("TRADER");
  const userId = trader?.user?.user?.userId;

  const [repId, setRepId] = useState("");
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  ).toLowerCase();

  const viewIcons = traderParent
    ? userId === parentData?.generatorTraderId ||
      userId === parentData?.consumerTraderId
    : role === "consumer"
      ? !parentData?.consumerTraderId
      : role === "generator"
        ? !parentData?.generatorTraderId
        : false;

  const [openPayout, setOpenPayouts] = useState(false);
  const [settlement, setSettlement] = useState({
    status: false,
    repId: "",
    schId: "",
    contractId: null,
  });
  const [walletActivities, setWalletActivities] = useState({
    open: false,
    loading: false,
    data: [],
  });

  const handleViewTransactions = async () => {
    setWalletActivities({ open: true, loading: true, data: [] });
    const res = await getWalletActivities({
      bilateralContractId: parentData?.bilateralContractUniqueId,
    });
    setWalletActivities({
      open: true,
      loading: false,
      data: res?.data?.data?.page || [],
    });
  };

  return (
    <>
      {settlement?.status && (
        <Settlement
          open={settlement?.status}
          handleClose={() =>
            setSettlement({
              status: false,
              repId: "",
              schId: "",
              contractId: null,
            })
          }
          paymentData={settlement}
          paymentScreen={true}
          // isInLdcCharge={true}
          heading={
            settlement?.contractId
              ? "LDC Charge Details"
              : "Transaction Details"
          }
        />
      )}
      {openPayout && (
        <Payouts
          open={openPayout}
          handleClose={() => setOpenPayouts(false)}
          viewOnly={true}
          id={parentData?.bilateralContractId}
          repId={repId}
        />
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.dailyContractModal}`}>
          <div className={Styles.dailyContractHeader}>
            <div>
              <div className={Styles.dailyContractTitle}>
                View Daily Contract
              </div>
            </div>

            <div onClick={handleClose}>
              <Close style={{ fontSize: "18px", cursor: "pointer" }} />
            </div>
          </div>
          <div className={Styles.dailySummaryGrid}>
            {/* CONTRACT ID */}
            <div className={Styles.summaryCard}>
              <div className={Styles.summaryLabel}>Contract ID</div>

              <div className={Styles.summaryValue}>
                {parentData?.bilateralContractUniqueId || "-"}
              </div>
            </div>

            {/* SELF LISTING */}
            <div className={Styles.summaryCard}>
              <div className={Styles.summaryLabel}>Self Listing</div>

              <div className={Styles.summaryValue}>
                {
                  (role === "consumer"
                    ? parentData?.name?.split("-")?.[0]?.includes("C")
                      ? parentData?.name?.split("-")?.[0]
                      : parentData?.name?.split("-")?.[1]
                    : parentData?.name?.split("-")?.[1]?.includes("G")
                      ? parentData?.name?.split("-")?.[1]
                      : parentData?.name?.split("-")?.[0]
                  )?.split("_")?.[0]
                }
              </div>
            </div>

            {/* COUNTERPARTY */}
            <div className={Styles.summaryCard}>
              <div className={Styles.summaryLabel}>Counterparty</div>

              <div className={Styles.summaryValue}>
                {role === "consumer"
                  ? `${parentData?.generatorName}`
                  : role === "generator"
                    ? `${parentData?.consumerName}`
                    : `${parentData?.consumerName}-${parentData?.generatorName}`}
              </div>
            </div>

            {/* VALUE */}
            <div className={Styles.summaryCard}>
              <div className={Styles.summaryLabel}>Total Contract Value</div>

              <div className={Styles.summaryValue}>
                ₹ {(parentData?.scheduledAmount || 0)?.toFixed(2)}
              </div>
            </div>

            {/* BLOCKED */}
            <div className={Styles.summaryCard}>
              <div className={Styles.summaryLabel}>Amount Blocked</div>

              <div className={Styles.summaryBlocked}>
                ₹ {(parentData?.amountBlocked || 0)?.toFixed(2)}
              </div>
            </div>

            {/* STATUS */}
            <div className={Styles.summaryCard}>
              <div className={Styles.summaryLabel}>Schedule</div>

              <div
                className={`${Styles.summaryStatus} ${
                  parentData?.status === "COMPLETED"
                    ? Styles.summaryCompleted
                    : parentData?.status === "PENDING"
                      ? Styles.summaryOngoing
                      : Styles.summaryRejected
                }`}
              >
                {parentData?.status === "COMPLETED"
                  ? "Completed"
                  : parentData?.status === "PENDING"
                    ? "Ongoing"
                    : "Rejected"}
              </div>
            </div>

            {/* LDC */}
            <div className={Styles.summaryCard}>
              <div className={Styles.summaryLabel}>LDC Charges</div>

              <div
                className={Styles.summaryAction}
                onClick={() => {
                  setSettlement({
                    status: true,
                    repId: "",
                    schId: "",
                    contractId: parentData?.bilateralContractId,
                  });
                }}
              >
                <RemoveRedEyeIcon
                  style={{ fontSize: "16px", color: "#f97316" }}
                />
              </div>
            </div>

            {/* TRANSACTIONS */}
            <div className={Styles.summaryCard}>
              <div className={Styles.summaryLabel}>Transactions</div>

              <div
                className={Styles.summaryAction}
                onClick={handleViewTransactions}
              >
                <RemoveRedEyeIcon
                  style={{ fontSize: "16px", color: "#f97316" }}
                />
              </div>
            </div>
          </div>
          <div className={Styles.dailyTableWrapper}>
            {/* TABLE HEADER */}
            <div className={Styles.dailyTableHeader}>
              <div className={Styles.dailyColSm}>Date</div>

              <div className={Styles.dailyColLg}>Time Range</div>

              <div className={Styles.dailyColMd}>Sch Qty (MWh)</div>

              <div className={Styles.dailyColLg}>
                <div className={Styles.headerWithIcon}>
                  Est. Amount (₹)
                  <Tooltip
                    title={"Estimated amount as per schedule quantum."}
                    arrow
                  >
                    <Info
                      style={{
                        fontSize: 14,
                        color: "#94a3b8",
                      }}
                    />
                  </Tooltip>
                </div>
              </div>

              <div className={Styles.dailyColLg}>Amount Blocked (₹)</div>

              <div className={Styles.dailyActionCol}>Breakdown</div>

              <div className={Styles.dailyActionCol}>Payouts</div>
            </div>

            {/* TABLE BODY */}
            <div className={Styles.dailyTableBody}>
              {Object.entries(
                (data || []).reduce((groups, ele) => {
                  const key = ele?.scheduleId ?? "unknown";

                  if (!groups[key]) groups[key] = [];

                  groups[key].push(ele);

                  return groups;
                }, {}),
              ).map(([scheduleId, groupItems]) => (
                <div key={scheduleId} className={Styles.scheduleGroupCard}>
                  {groupItems.map((ele, index) => (
                    <div key={index} className={Styles.dailyTableRow}>
                      {/* DATE */}
                      <div className={Styles.dailyColSm}>
                        <div className={Styles.dailyPrimaryText}>
                          {convertDate(ele?.date)}
                        </div>
                      </div>

                      {/* TIME */}
                      <div className={Styles.dailyColLg}>
                        <div className={Styles.dailyPrimaryText}>
                          {ele?.scheduleStartTime?.split(":")?.[0]}:
                          {ele?.scheduleStartTime?.split(":")?.[1]} to{" "}
                          {ele?.scheduleEndTime === "23:59:59"
                            ? "24:00"
                            : `${ele?.scheduleEndTime?.split(":")?.[0]}:${
                                ele?.scheduleEndTime?.split(":")?.[1]
                              }`}
                        </div>
                      </div>

                      {/* VOLUME */}
                      <div className={Styles.dailyColMd}>
                        <div className={Styles.dailyMetric}>
                          {(ele?.volume || 0)?.toFixed(2)} MWh
                        </div>
                      </div>

                      {/* AMOUNT */}
                      <div className={Styles.dailyColLg}>
                        <div className={Styles.dailyAmount}>
                          ₹ {(ele?.amount || 0)?.toFixed(2)}
                        </div>
                      </div>

                      {/* BLOCKED */}
                      <div className={Styles.dailyColLg}>
                        <div className={Styles.dailyBlocked}>
                          ₹ {(ele?.amountBlocked || 0)?.toFixed(2)}
                        </div>
                      </div>

                      {/* BREAKDOWN */}
                      <div className={Styles.dailyActionCol}>
                        <div
                          className={`${Styles.dailyIconButton} ${Styles.breakView}`}
                          onClick={() => {
                            setSettlement({
                              status: true,
                              repId: ele?.repScheduleId,
                              schId: ele?.scheduleId,
                              contractId: null,
                            });
                          }}
                        >
                          <RemoveRedEyeIcon
                            style={{
                              fontSize: "15px",
                              color: "var(--primary-color-text)",
                            }}
                          />
                        </div>
                      </div>

                      {/* PAYOUT */}
                      <div className={Styles.dailyActionCol}>
                        <div
                          className={Styles.dailyIconButton}
                          onClick={() => {
                            setOpenPayouts(true);
                            setRepId(ele?.repScheduleId);
                          }}
                        >
                          <ReceiptLongIcon
                            style={{
                              fontSize: "15px",
                              color: "var(--primary-color-text)",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        open={walletActivities.open}
        onClose={() =>
          setWalletActivities({ open: false, loading: false, data: [] })
        }
      >
        <div className={`popupModal ${Styles.childTransactionModal}`}>
          <div className="modalHeading">
            Wallet Transactions
            <Close
              onClick={() =>
                setWalletActivities({ open: false, loading: false, data: [] })
              }
              style={{ cursor: "pointer" }}
              alterbutton="false"
            />
          </div>
          {walletActivities.loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "32px",
              }}
            >
              <CircularProgress
                size={28}
                style={{ color: "var(--primary-color-text)" }}
              />
            </div>
          ) : (
            <div className={Styles.tableContainer}>
              <div className="tableHeading display_flex_row">
                <div style={{ width: "20%" }}>Listing ID</div>
                <div style={{ width: "14%" }}>Counter Party</div>
                {/* <div style={{ width: "18%" }}>Contract ID</div> */}
                <div style={{ width: "18%" }}>Transaction Date</div>
                <div style={{ width: "18%" }}>Transaction Amount (₹)</div>
                <div style={{ width: "18%" }}>Type</div>
                <div style={{ width: "12%" }}>Action</div>
              </div>
              <div className={`scroll_bar_y ${Styles.childTransactionTable}`}>
                {walletActivities.data.length === 0 ? (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "24px",
                      color: "#999",
                      fontSize: "12px",
                    }}
                  >
                    No transactions found.
                  </div>
                ) : (
                  walletActivities.data.map((item) => (
                    <div
                      key={item.id}
                      className="tableDetails display_flex_row"
                    >
                      <div style={{ width: "20%" }}>
                        {item.listingId.split("_")[0] || "-"}
                      </div>
                      <div style={{ width: "14%" }}>
                        {item.counterPartyName || "-"}
                      </div>
                      {/* <div style={{ width: "18%" }}>
                        {item.bilateralContractUniqueId || "-"}
                      </div> */}
                      <div style={{ width: "18%" }}>
                        {convertDate(item.dateTime) || "-"}
                      </div>
                      <div style={{ width: "18%" }}>
                        {(item.amount || 0).toFixed(2)}
                      </div>
                      <div
                        style={{
                          width: "18%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item?.paymentType?.split("_")?.join(" ") || "-"}
                      </div>
                      <div
                        style={{ width: "12%" }}
                        className={
                          item?.activity === "CREDIT" ||
                          item?.activity === "RELEASED"
                            ? "accepted"
                            : "rejected"
                        }
                      >
                        {item.activity || "-"}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default ChildTransaction;
